import { useState } from "react";

export const useUpdateStatus = (open: boolean) => {
    const [form, setForm ] = useState({
		filters: Object,
		updates: {
			active: "",
			expired_date: ""
		},
		type: "",
	})

	const createForm = (data, type) => {
		let request = {
			filters: {
				entity_uuid: data.entity_uuid,
				operation: data.operation,
				channel: data.channel
			},
			updates: {
				active: data.active ? false : true,
				enabled: data.enabled ? false : true,
				expired_date: new Date().toJSON()
			},
			type: type
		}
		setForm(JSON.parse(JSON.stringify(request)))
	}
 
	const onHandleChange = (e) => {
		let f = form
		f['updates']['expired_date'] = new Date(e.target.value).toJSON()
		setForm(JSON.parse(JSON.stringify(f)));
	}

    return { form, onHandleChange, createForm }
};